import { BaseValue } from "../base/base-value";
import { CalcRequestItemValidator } from "./calc-request-item-validator";
import {
  MaxInvoiceItems,
  PaymentConst,
  PaymentMethod,
  TaxRateLiterals,
} from "@graffer-inc/cloud-gov-core";

export type CalcRequestType = {
  items: CalcRequestItem[];
  inclusive: boolean;
  message: string;
  internalComment: string;
  acceptedPaymentMethods: PaymentMethod[];
};

export type CalcRequestItem = {
  amount: number;
  taxRate: TaxRateLiterals;
  description: string;
};

/**
 * 後決済のPaymentの内容を構築する上での計算要求用のバリューオブジェクト
 */
export class CalcRequestValue extends BaseValue<CalcRequestType> {
  get inclusive() {
    return this.value.inclusive;
  }

  get items() {
    return this.value.items;
  }

  isValid() {
    return (
      this.value.items.length > 0 &&
      this.value.items.length < MaxInvoiceItems &&
      !this.acceptedPaymentMethodsError() &&
      !this.messageError() &&
      !this.value.items.some(
        (v) => Object.keys(this.validateItem(v)).length !== 0,
      )
    );
  }

  updateAcceptedPaymentMethods(paymentMethods: PaymentMethod[]) {
    this.value.acceptedPaymentMethods = paymentMethods;
    return this;
  }

  updateMessage(msg: string) {
    this.value.message = msg;
    return this;
  }

  update(item: CalcRequestItem, index: number) {
    this.value.items = this.value.items.map((i, idx) =>
      idx === index ? item : i,
    );
    return this;
  }

  acceptedPaymentMethodsError() {
    return this.value.acceptedPaymentMethods.length === 0
      ? "支払い手段を選択してください。"
      : undefined;
  }

  messageError() {
    return this.value.message.length > PaymentConst.MAX_PAYMENT_MESSAGE_LENGTH
      ? "メッセージは300文字以内で入力してください。"
      : undefined;
  }

  remove(index: number) {
    this.value.items = this.items.filter((_, idx) => idx !== index);
    return this;
  }

  addItem() {
    this.value.items = [
      ...this.value.items,
      {
        amount: 0,
        taxRate: "0.1",
        description: "",
      },
    ];
    return this;
  }

  copy() {
    return new CalcRequestValue(JSON.parse(JSON.stringify(this.value)));
  }

  static initial() {
    return new CalcRequestValue({
      inclusive: true,
      items: [
        {
          amount: 0,
          taxRate: "0.1",
          description: "",
        },
      ],
      message: "",
      internalComment: "",
      acceptedPaymentMethods: ["credit_card"],
    });
  }

  static fromJSON(v: CalcRequestType) {
    return new CalcRequestValue(v);
  }

  private validateItem(item: CalcRequestItem) {
    return new CalcRequestItemValidator(item).validate();
  }
}
